import React from "react";
import { Container, Button, Row, Col, Card } from "react-bootstrap";
import "./listedproject.css";
import BackArrow from "../../../components/backArrow";
import { images } from "../../../constants";
import ModeIcon from "@mui/icons-material/Mode";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { MainModal } from "@/components";


const MyListedPrograms = () => {
  const investments = [
    {
      id: 1,
      image: images.Wallet1,
      title: "Startup Z",
      details:
        "Invested Amount: $7,000 | Current Value: $8,400 | Profit: +$1,400 (20%) | Investment Date: 2024-07-20 | Status: Active | Time Remaining: 15 days | Plan Duration: Matures on Sep 1, 2025",
    },
    {
      id: 2,
      image: images.Wallet1,
      title: "Tech Startup Gamma",
      details:
        "Invested Amount: $3,000 | Current Value: $3,300 | Profit: +$300 (10%) | Investment Date: 2024-07-25 | Status: Active | Time Remaining: 20 days | Plan Duration: Matures on Oct 1, 2025",
    },

    {
      id: 3,
      image: images.Wallet1,
      title: "Startup Z",
      details:
        "Invested Amount: $7,000 | Current Value: $8,400 | Profit: +$1,400 (20%) | Investment Date: 2024-07-20 | Status: Active | Time Remaining: 15 days | Plan Duration: Matures on Sep 1, 2025",
    },
    {
      id: 4,
      image: images.Wallet1,
      title: "Tech Startup Gamma",
      details:
        "Invested Amount: $3,000 | Current Value: $3,300 | Profit: +$300 (10%) | Investment Date: 2024-07-25 | Status: Active | Time Remaining: 20 days | Plan Duration: Matures on Oct 1, 2025",
    },

    {
      id: 5,
      image: images.Wallet1,
      title: "Startup Z",
      details:
        "Invested Amount: $7,000 | Current Value: $8,400 | Profit: +$1,400 (20%) | Investment Date: 2024-07-20 | Status: Active | Time Remaining: 15 days | Plan Duration: Matures on Sep 1, 2025",
    },
    {
      id: 6,
      image: images.Wallet1,
      title: "Tech Startup Gamma",
      details:
        "Invested Amount: $3,000 | Current Value: $3,300 | Profit: +$300 (10%) | Investment Date: 2024-07-25 | Status: Active | Time Remaining: 20 days | Plan Duration: Matures on Oct 1, 2025",
    },
  ];
  
const [shows, setShows] = useState(false);  
const navigate=useNavigate();
const handleClose = () => setShows(false);
const Deleteitem=()=>{
    
}

  return (
    <Row>
       <MainModal
          variant="deleteModal"
          show={shows}
          title="Program"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
        />
      <div className="screenHeight d-lg-flex justify-content-center  p-3">
        <Col
          lg="8"
          className="listed-programs-page b-radius shadow"
          style={{ backgroundColor: "#F7FAFC" }}
        >
          <Container className="p-4">
            <BackArrow />
            <h4 className="fw-bold mb-3 mt-3">My Listed programs</h4>
            <h6 className="text-dark mb-3">Active Investments</h6>

            <div className="scrollable-area">
              {investments.map((item) => (
                <Card key={item.id} className="investment-card mt-2">
                  <Row className="g-0 align-items-center">
                    <Col md={4} className="img-container">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="card-img"
                      />
                    </Col>
                    <Col md={8}>
                      <Card.Body className="pt-3 pb-3">
                        <Card.Title className="fw-bold">
                          {item.title}
                        </Card.Title>
                        <Card.Text
                          className="font_13 w-75"
                          style={{ color: "#475C9E !important" }}
                        >
                          {item.details}
                        </Card.Text>
                        <div className="d-flex gap-2 mt-4">
                          <button
                            type="button"
                            className="pill-btn btn btn-primary"
                            onClick={()=>navigate("/project-details")}
                          >
                            View Details
                          </button>
                          <Button className="pill-btn" style={{backgroundColor:"#0353a4 !important"}} onClick={()=>navigate("/update-seekar-form")}>
                            <ModeIcon fontSize="small"  /> &nbsp;
                            Edit
                          </Button>
                          <button type="button" className="pill-btn btn btn-danger" onClick={() => setShows(true)}>
                            <DeleteIcon ModeIcon fontSize="small" />&nbsp; Delete
                          </button>
                        </div>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              ))}
            </div>
          </Container>
        </Col>
      </div>
    </Row>
  );
};

export default MyListedPrograms;
